<cfp-side-panel [title]="'tags' | translate" (closeClicked)="close()" [dataTest]="'portfolioTagsModal'">
  <ng-container body>
    <cfp-tags-toolbar
      [portfolioId]="portfolioId"
      [searchText]="searchText()"
      (searchTextChange)="search($event)"
      (fetchTags)="fetchTags()"
    />

    <cfp-table [data]="filteredTags()" [columns]="columns">
      <ng-template let-row="row">
        <tr class="table-row cursor-pointer" [attr.data-test]="row.tag">
          <td>
            {{ row.tag }}
          </td>
          <td>{{ row.nrOfBuildings }}</td>
          <td>
            <cfp-button
              [buttonStyle]="'link'"
              [classes]="'p-0 text-danger'"
              (clicked)="deleteTag(row)"
              [dataTest]="'deleteTagButton'"
            >
              {{ 'delete.button' | translate }}
            </cfp-button>
          </td>
        </tr>
      </ng-template>
    </cfp-table>
  </ng-container>
</cfp-side-panel>
